<div
  class="admin-set-post-tracking-code-container"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <mat-form-field appearance="outline">
    <mat-label>کد ۲۴ رقمی پیگیری سفارش</mat-label>
    <input
      [formControl]="inputControl"
      #postTrackingCode
      type="number"
      minlength="24"
      matInput
    />
    <jam-icon name="qr-code" matSuffix></jam-icon>
  </mat-form-field>
  <button
    [disabled]="!this.inputControl.valid"
    mat-flat-button
    color="primary"
    (click)="saveCode(postTrackingCode.value)"
  >
    ثبت کد <jam-icon name="check"></jam-icon>
  </button>
</div>
